<div class="p-5 flex flex-col gap-3">
  <h3 class="!m-0 font-semibold">{{'You Will Be Logged Out In' | translate}}</h3>
  <div><span class="text-lg font-bold text-red-500">{{countdown$ | async}}</span> <span class="font-semibold">&nbsp; sec(s)</span></div>
  <div class="flex gap-2 justify-between">
    <button mat-flat-button color="primary" (click)="close()">{{'Keep Me In' | translate}}</button>
    <button mat-button color="accent" (click)="logOut()">{{'Logout Me Out' | translate}}</button>
  </div>
</div>
